import OnboardingPrompt from "./OnboardingPrompt";

export default OnboardingPrompt;
